// @ts-nocheck

import "@legacy/entrypoints/custom-select";
// сайдбары мобильной шапки
import "@legacy/entrypoints/sidebar-overlay";
import "htmx.org";

// Смена языка
document
    .querySelectorAll("[data-select-language-form]")
    .forEach((selectLanguageForm) => {
        try {
            if (!(selectLanguageForm instanceof HTMLFormElement)) {
                throw "[data-select-language-form] is not instance of HTMLFormElement";
            }
            const cultureSelect =
                /** @type {HTMLInputElement} */ selectLanguageForm.querySelector(
                    "#culture",
                );
            cultureSelect.addEventListener("change", () => {
                selectLanguageForm.submit();
            });
        } catch (err) {
            console.error(err);
        }
    });

// Смена валюты
document
    .querySelectorAll("[data-select-currency-form]")
    .forEach((selectCurrencyForm) => {
        try {
            if (!(selectCurrencyForm instanceof HTMLFormElement)) {
                throw "[data-select-currency-form] is not instance of HTMLFormElement";
            }
            const currencySelect =
                /** @type {HTMLInputElement} */ selectCurrencyForm.querySelector(
                    "#currency",
                );
            currencySelect.addEventListener("change", () => {
                selectCurrencyForm.submit();
            });
        } catch (err) {
            console.error(err);
        }
    });
